import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#900028",
    },
    secondary: {
      main: "#000000",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#333333",
      secondary: "#000000",
    },
  },

  typography: {
    h1: {
      color: "#900028",
      fontWeight: 700,
      textAlign: "center",
      fontSize: "2rem",
      "@media (min-width:600px)": {
        fontSize: "2.6rem",
      },
      "@media (min-width:900px)": {
        fontSize: "3.2rem",
      },
    },

    h2: {
      color: "#900028",
      fontWeight: 700,
      textAlign: "center",
      fontSize: "1.7rem",
      "@media (min-width:600px)": {
        fontSize: "2.2rem",
      },
      "@media (min-width:900px)": {
        fontSize: "2.6rem",
      },
    },

    h3: {
      color: "#900028",
      fontWeight: 700,
      textAlign: "center",
      fontSize: "1.45rem",
      "@media (min-width:600px)": {
        fontSize: "1.8rem",
      },
      "@media (min-width:900px)": {
        fontSize: "2.1rem",
      },
    },

    h4: {
      color: "#000000",
      fontWeight: 600,
      textAlign: "left",
      fontSize: "1.25rem",
      "@media (min-width:600px)": {
        fontSize: "1.4rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.6rem",
      },
    },

    body1: {
      color: "#333333",
      textAlign: "left",
      fontSize: "0.95rem",
      "@media (min-width:600px)": {
        fontSize: "1rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.05rem",
      },
    },

    body2: {
      color: "#333333",
      textAlign: "left",
      fontSize: "0.9rem",
      "@media (min-width:600px)": {
        fontSize: "0.95rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1rem",
      },
    },
  },

  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
        variant: "outlined",
      },
    },

    MuiSelect: {
      defaultProps: {
        size: "small",
      },
    },

    MuiFormControl: {
      defaultProps: {
        size: "small",
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});

export default theme;